import HelperCalendar from './HelperCalendar'
import HelperServiceDescription from './HelperServiceDescription'

const Helper = {
  Calendar: HelperCalendar,
  ServiceDescription: HelperServiceDescription,
}

export default Helper